// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-card {
  overflow: hidden;
}
.statistics-card .card-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 200px;
}
.statistics-card .space {
  flex-grow: 1;
}
.statistics-card .highlighter {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-40%, -50%);
}
.statistics-card .highlighter.green {
  animation: shinerGreen 1.2s infinite;
}
.statistics-card .highlighter.red {
  animation: shinerRed 1.2s infinite;
}
.statistics-card .highlighter.grey {
  animation: shinerGrey 1.2s infinite;
}
.statistics-card .highlighter.purple {
  animation: shinerPurple 1.2s infinite;
}
.statistics-card .content {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  width: 100%;
  text-align: center;
}
.statistics-card .content .number {
  position: absolute;
  top: 30%;
  font-weight: 700;
  word-break: break-all;
  word-wrap: break-word;
  text-align: center;
}
.statistics-card .title {
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.avatar {
  width: 50%;
}
.avatar .avatar-text {
  width: calc(100% - 56px);
}
.avatar .avatar-text .title {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}

@keyframes shinerGreen {
  0% {
    box-shadow: 0px 0px 45px 45px rgba(39, 227, 58, 0.1);
  }
  50% {
    box-shadow: 0px 0px 50px 50px rgba(39, 227, 58, 0.3);
  }
  100% {
    box-shadow: 0px 0px 45px 45px rgba(39, 227, 58, 0.1);
  }
}
@keyframes shinerRed {
  0% {
    box-shadow: 0px 0px 45px 45px rgba(255, 140, 140, 0.1);
  }
  50% {
    box-shadow: 0px 0px 50px 50px rgba(255, 140, 140, 0.3);
  }
  100% {
    box-shadow: 0px 0px 45px 45px rgba(255, 140, 140, 0.1);
  }
}
@keyframes shinerGrey {
  0% {
    box-shadow: 0px 0px 45px 45px rgba(181, 174, 174, 0.1);
  }
  50% {
    box-shadow: 0px 0px 50px 50px rgba(181, 174, 174, 0.3);
  }
  100% {
    box-shadow: 0px 0px 45px 45px rgba(181, 174, 174, 0.1);
  }
}
@keyframes shinerPurple {
  0% {
    box-shadow: 0px 0px 45px 45px rgba(135, 232, 222, 0.1);
  }
  50% {
    box-shadow: 0px 0px 50px 50px rgba(135, 232, 222, 0.3);
  }
  100% {
    box-shadow: 0px 0px 45px 45px rgba(135, 232, 222, 0.1);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/dashboard.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAEJ;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAEJ;AAAI;EACE,oCAAA;AAEN;AAAI;EACE,kCAAA;AAEN;AAAI;EACE,mCAAA;AAEN;AAAI;EACE,qCAAA;AAEN;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAAI;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;AAEN;AAEE;EACE,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;;AAGA;EACE,UAAA;AAAF;AACE;EACE,wBAAA;AACJ;AAAI;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAEN;;AAGA;EACE;IACE,oDAAA;EAAF;EAEA;IACE,oDAAA;EAAF;EAEA;IACE,oDAAA;EAAF;AACF;AAEA;EACE;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;AACF;AAEA;EACE;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;AACF;AAEA;EACE;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;EAEA;IACE,sDAAA;EAAF;AACF","sourcesContent":[".statistics-card {\n  overflow: hidden;\n  .card-wrapper {\n    display: flex;\n    flex-direction: column;\n    min-height: 200px;\n  }\n  .space {\n    flex-grow: 1;\n  }\n  .highlighter {\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    transform: translate(-40%, -50%);\n\n    &.green {\n      animation: shinerGreen 1.2s infinite;\n    }\n    &.red {\n      animation: shinerRed 1.2s infinite;\n    }\n    &.grey {\n      animation: shinerGrey 1.2s infinite;\n    }\n    &.purple {\n      animation: shinerPurple 1.2s infinite;\n    }\n  }\n  .content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n    width: 100%;\n    text-align: center;\n    .number {\n      position: absolute;\n      top: 30%;\n      font-weight: 700;\n      word-break: break-all;\n      word-wrap: break-word;\n      text-align: center;\n    }\n  }\n\n  .title {\n    text-align: center;\n  }\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.avatar {\n  width: 50%;\n  .avatar-text {\n    width: calc(100% - 56px);\n    .title {\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 0;\n    }\n  }\n}\n\n@keyframes shinerGreen {\n  0% {\n    box-shadow: 0px 0px 45px 45px rgba(39, 227, 58, 0.1);\n  }\n  50% {\n    box-shadow: 0px 0px 50px 50px rgba(39, 227, 58, 0.3);\n  }\n  100% {\n    box-shadow: 0px 0px 45px 45px rgba(39, 227, 58, 0.1);\n  }\n}\n@keyframes shinerRed {\n  0% {\n    box-shadow: 0px 0px 45px 45px rgba(255, 140, 140, 0.1);\n  }\n  50% {\n    box-shadow: 0px 0px 50px 50px rgba(255, 140, 140, 0.3);\n  }\n  100% {\n    box-shadow: 0px 0px 45px 45px rgba(255, 140, 140, 0.1);\n  }\n}\n@keyframes shinerGrey {\n  0% {\n    box-shadow: 0px 0px 45px 45px rgba(181, 174, 174, 0.1);\n  }\n  50% {\n    box-shadow: 0px 0px 50px 50px rgba(181, 174, 174, 0.3);\n  }\n  100% {\n    box-shadow: 0px 0px 45px 45px rgba(181, 174, 174, 0.1);\n  }\n}\n@keyframes shinerPurple {\n  0% {\n    box-shadow: 0px 0px 45px 45px rgba(135, 232, 222, 0.1);\n  }\n  50% {\n    box-shadow: 0px 0px 50px 50px rgba(135, 232, 222, 0.3);\n  }\n  100% {\n    box-shadow: 0px 0px 45px 45px rgba(135, 232, 222, 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
